import React from 'react';
import classNames from 'classnames';

import crossIcon from './assets/cross.svg';

import './styles.css';

interface ToggleSwitchWithNumberProps {
  number: number;
  onChange: () => void;
}

const ToggleSwitchWithNumber: React.FC<ToggleSwitchWithNumberProps> = ({
  number,
  onChange
}) => (
  <div
    className={classNames('ToggleSwitchWithNumber colab-clickable', {
      'ToggleSwitchWithNumber--active': number > 0
    })}
    onClick={onChange}>
    <div className="ToggleSwitchWithNumber__number colab-bold">{number}</div>
    <div className="ToggleSwitchWithNumber__switch colab-centered">
      {number > 0 && <img src={crossIcon} alt="" />}
    </div>
  </div>
);

export default ToggleSwitchWithNumber;
